import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Galería", href: "#galeria" },
  { label: "Valores", href: "#valores" },
  { label: "Contacto", href: "#contacto" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="absolute top-0 inset-x-0 z-50"
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-28 flex items-center justify-between">
        <a href="#inicio" data-testid="nav-logo" className="flex items-center group">
          <img
            src="/logo-jan-dark.png"
            alt="JAN — Servicio y Mantenimiento Minero"
            className="h-24 w-auto transition-transform duration-200 group-hover:scale-105"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="font-body text-sm uppercase tracking-widest text-neutral-300 hover:text-[#FF1616] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contacto"
            data-testid="nav-cta-cotizar"
            className="bg-[#FF1616] hover:bg-[#CC0F0F] text-black font-heading font-bold uppercase tracking-wider text-sm px-6 py-3 transition-colors"
          >
            Cotizar
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-black border-t border-[#262626] px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-body uppercase tracking-widest text-sm text-neutral-200 hover:text-[#FF1616]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={() => setOpen(false)}
            className="bg-[#FF1616] text-black font-heading font-bold uppercase text-center py-3"
          >
            Cotizar
          </a>
        </div>
      )}
    </header>
  );
};
